(function () {
  if (window.__drexeyTextLinkDialog) return;
  window.__drexeyTextLinkDialog = true;
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-text-link-dialog]');
    if (trigger) {
      var dialog = document.getElementById(trigger.getAttribute('data-text-link-dialog'));
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    var close = event.target.closest('[data-text-link-close]');
    if (close) {
      close.closest('dialog').close();
      return;
    }
    if (event.target.matches('.product-text-link-dialog')) {
      var bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
})();
